import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import './Top.Module.scss';
import {NavLink as NavLinkRouter} from 'react-router-dom';

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faSignOut, faSignIn, faUser } from '@fortawesome/pro-solid-svg-icons';
import {  } from '@fortawesome/pro-regular-svg-icons';


const mapStateToProps = (state, props) => {
    return {
        authentication: state.authentication
    };
};

class Top extends Component {


    render() {
        console.log('autenticatie', this.props.authentication)

        const NavLink = props => (
            <NavLinkRouter {...props} isActive={(match, location) => {

                if(location.pathname == '/platform' && props.to.pathname == undefined) {
                    return true;
                }

                return location.pathname.startsWith(props.to.pathname)}
            }/>
        );

        return (
        <Fragment>
            <div styleName='topwrap'>
                <div styleName='left'>
                    <NavLink  target="_blank" to="/">
                        <div styleName='logowrap'>
                            <div styleName='logo'></div>
                        </div>
                    </NavLink>
                    <NavLink to="/platform">
                        <h4>
                            LESMATERIAAL
                        </h4>
                    </NavLink>
                    
                    <NavLink to={{pathname:'/voorbeeldleerlijn'}}>
                        <h4>
                            VOORBEELD LEERLIJN
                        </h4>
                    </NavLink>
                   
                    <NavLink to={{pathname:'/uitleg'}}>
                        <h4>
                            FAQ
                        </h4>
                    </NavLink>
                    {/* <NavLink to={{pathname:'/favorieten'}}>
                        <h4>
                            Favorieten
                        </h4>
                    </NavLink>
                */}
                </div>
                <div styleName='right'>
                    {
                        this.props.authentication.isLoggedIn ?

                        <Fragment>
                            {/* <NavLink style={{display:'flex'}} to={{pathname:'/inloggen'}}>
                            <FontAwesomeIcon styleName='sing-out-icon' icon={faSignOut}/>
                            <h4>  LOG UIT</h4>
                            </NavLink> */}
                            
                            <NavLink style={{display:'flex'}} to={{pathname:'/profile'}}>
                                <FontAwesomeIcon styleName='sing-out-icon' icon={faUser}/>
                                <h4>{this.props.authentication.user.name}</h4>
                            </NavLink>
                        </Fragment>
                        :
                        <Fragment>
                            <NavLink style={{display:'flex'}} to={{pathname:'/inloggen'}}>
                                <FontAwesomeIcon styleName='sing-out-icon' icon={faSignIn}/>
                                <h4>  LOG IN</h4>
                            </NavLink>
                        </Fragment>
                    }
                    
                </div>
            </div>
        </Fragment>
        );
    }
}

export default connect(mapStateToProps, null)(Top);